import {
  CallToAction,
  CollectionOptions,
  Component,
  ComponentLayout,
  DynamicTitle,
  ExportOptions,
  GenAiOptions,
  Period,
  SettingsProvider,
} from '../../../types';
import { ContentFactory } from '../content';
import { DataOptionsFactory } from '../data';

export type NoDataInfoType = 'ignore' | 'info-alert' | 'default';

export type ComponentOptions = {
  data?: DataOptionsFactory;
  heading?: {
    subTitle?: string;
    title: string | DynamicTitle;
    isCollapsible?: boolean;
    customPeriodOptions?: Period[];
    isFilterDisabled?: boolean;
  };
  callsToAction?: CallToAction[];
  contents: {
    fixed?: ContentFactory[];
    endpoint?: string;
    aboveFold?: number;
  };
  settingsProvider?: SettingsProvider;
  asCard?: boolean;
  noDataInfoType?: NoDataInfoType;
  layout?: ComponentLayout;
  exportOptions?: ExportOptions;
  collectionOptions?: CollectionOptions;
  genAiOptions?: GenAiOptions;
};

export class ComponentFactory {
  name: string;
  options: ComponentOptions;

  constructor(name: string, options: ComponentOptions) {
    this.name = name;
    this.options = options;
  }

  _build(): Component {
    const {
      data,
      noDataInfoType,
      heading,
      callsToAction,
      contents,
      settingsProvider,
      asCard,
      layout,
      exportOptions,
      collectionOptions,
      genAiOptions,
    } = this.options;
    return {
      contents: {
        fixed: contents.fixed?.map(c => c._build()),
        endpoint: contents.endpoint,
        aboveFold: contents.aboveFold,
      },
      heading: heading,
      name: this.name,
      callsToAction,
      settings: settingsProvider || {
        values: {},
        dataSettings: [],
        metadata: {},
      },
      dataOptions: data?._build(),
      asCard,
      noDataInfoType,
      layout,
      exportOptions,
      collectionOptions,
      genAiOptions,
    };
  }
}
